import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/contexts/WishlistContext";
import { sgd, resolveImage } from "@/lib/api";

export default function LookCard({ look, index = 0 }) {
  const { has, toggle } = useWishlist();
  const wished = has(look.id);
  return (
    <Link data-testid={`look-card-${look.slug}`} to={`/looks/${look.slug}`} className="group block hover-lift" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="relative overflow-hidden" style={{ background: "#EBE5ED" }}>
        <img src={resolveImage(look.hero_image)} alt={look.name} className="w-full aspect-[3/4] object-cover transition-transform duration-[900ms] ease-[cubic-bezier(.2,.7,.2,1)] group-hover:scale-[1.04]" />
        <button onClick={(e) => { e.preventDefault(); toggle(look.id); }} data-testid={`wishlist-toggle-${look.slug}`}
                className="absolute top-3 right-3 w-9 h-9 rounded-full backdrop-blur-md flex items-center justify-center transition-colors" style={{ background: "rgba(253,251,247,0.8)" }}>
          <Heart size={16} strokeWidth={1.2} fill={wished ? "#C3B1C5" : "none"} stroke={wished ? "#C3B1C5" : "#4A464A"} />
        </button>
        {look.is_new && <div className="absolute top-3 left-3 text-[10px] uppercase tracking-editorial px-2 py-1" style={{ background: "#FDFBF7", color: "#4A464A" }}>New</div>}
      </div>
      <div className="pt-4 pb-2">
        <div className="text-[10px] uppercase tracking-editorial text-[#C3B1C5]">LOOK {look.number}</div>
        <div className="font-serif-display text-[19px] md:text-[20px] mt-1">{look.name}</div>
        <div className="text-[12px] mt-1 text-[#4A464A]/70 line-clamp-1">{look.description}</div>
        <div className="text-[13px] mt-2 tracking-editorial">{sgd(look.bundle_price)} <span className="text-[#4A464A]/50">/ Complete Look</span></div>
      </div>
    </Link>
  );
}
